import React from 'react';
import { TDropdownProps } from './Dropdown.type';
import { SDropdown } from './Dropdown.style';

const Dropdown: React.FC<TDropdownProps> = (props) => {
  return <SDropdown {...props} />;
};

export { Dropdown };
